
import errorHandler from './errorHandler'
import axios from 'axios';
import api from '../../api'

export function replyDirectMessageWithAttachment(payload, next){
    console.log('girdi2')
    axios.post('http://localhost:5555/sendAttachment', payload.body).then((response) => {
      next(null, response.data);
    })
    .catch((err) => {
      if(err) return next(err, null);
    });
    }

    /*         api.post("localhost:5555/sendAttachment", payload.body, (err, data) => {
            if(err) return next(err, null);
            next(null, data);
        })    */


// WEBPACK FOOTER //
// ./src/libs/facebook/replyDirectMessageWithAttachment.js